import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Header, Button } from 'semantic-ui-react'

import Form from '../../components/elements/Form'
import TextInput from '../../components/elements/forms/TextInput'
import PasswordInput from '../../components/elements/forms/PasswordInput'
import Dismissible from '../../components/elements/Dismissible'

import Types from '../../actions/Types'
import LoginAction from '../../actions/auth/LoginAction'
import ClearErrorAction from '../../actions/app/ClearErrorAction'

import './LoginApp.css'

class LoginApp extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      username: '',
      password: ''
    }

    // Bind events
    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeUsername = this.onChangeUsername.bind(this)
    this.onChangePassword = this.onChangePassword.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // If error, need to reset fields
    if (
      prevProps.error !== this.props.error
      &&
      this.props.error
      &&
      this.props.error.status === 400
    ) {
      // If username error, need to reset all fields
      if (this.props.error.code === 'WRONG_USER') {
        this.setState({
          username: '',
          password: ''
        })
        this.usernameInput.focus()
      }

      // If password error, need to reset only password
      else if (this.props.error.code === 'WRONG_PASSWORD') {
        this.setState({
          password: ''
        })
        this.passwordInput.focus()
      }
    }
  }

  onSubmit() {
    this.props.login({
      username: this.state.username,
      password: this.state.password
    })
  }

  onChangeUsername(username) {
    this.setState({ username })
  }

  onChangePassword(password) {
    this.setState({ password })
  }

  render() {
    return (
      <div
        className='login-container'
      >
        <Header as='h1'>
          GestMat
        </Header>
        <Header as='h5'>
          Gestion du matériel du SIS Régional de la Basse-Allaine
        </Header>
        {
          (
            this.props.error
            &&
            this.props.error.code !== 'WRONG_USER'
            &&
            this.props.error.code !== 'WRONG_PASSWORD'
          )
            ? <Dismissible
                header='Erreur'
                content={this.props.error.message}
                color='red'
                onDismiss={this.props.clearError}
              />
            : null
        }
        <div
          className='form-container'
        >
          <div>
            <Form
              onSubmit={this.onSubmit}
              style={{
                marginTop: '16px',
                marginBottom: '16px'
              }}
            >
              <TextInput
                label="Utilisateur"
                placeholder="Nom d'utilisateur"
                value={this.state.username}
                onChange={this.onChangeUsername}
                error={
                  this.props.error
                  &&
                  this.props.error.status === 400
                  &&
                  this.props.error.code === 'WRONG_USER'
                    ? this.props.error.message
                    : null
                }
                fieldRef={(ref) => { this.usernameInput = ref }}
              />
              <PasswordInput
                label1="Mot de passe"
                placeholder="1234"
                value={this.state.password}
                onChange={this.onChangePassword}
                error={
                  this.props.error
                  &&
                  this.props.error.status === 400
                  &&
                  this.props.error.code === 'WRONG_PASSWORD'
                    ? this.props.error.message
                    : null
                }
                fieldRef1={(ref) => { this.passwordInput = ref }}
              />
            </Form>
          </div>
          <div>
            <Button
              circular={true}
              color='blue'
              icon='arrow right'
              onClick={this.onSubmit}
              loading={this.props.isFetching}
            />
          </div>
        </div>
      </div>
    )
  }
}

LoginApp.propTypes = {
  // Properties

  // Redux State
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,

  // Redux Actions
  login: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isFetching: state.app.identity.isFetching,
    error: state.app.identity.error
  }),
  (dispatch) => ({
    login: (data) => dispatch(LoginAction({ data })),
    clearError: () => dispatch(ClearErrorAction(Types.AUTH.LOGIN))
  })
)(LoginApp)



// WEBPACK FOOTER //
// ./src/containers/app/LoginApp.js